var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g(_vm._b({on:{"click":_vm.copyToClipboard}},'v-btn',_vm.$attrs,false),on),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.clipboardIcon)}})])]}}])},[_c('span',[_vm._v(_vm._s(_vm.clipboardTooltip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }